export const InitialValuesAssetGenerator = {
	reference: "",
	datePayment: "",
	assetEditor: "",
	amountRefund: "",
	reasonForTheAsset: "",
}